export const MT_BACKGROUND = 'rgb(141, 90, 58)';
export const OPTIONS_KEY = 'MT OPTIONS';
export const NORMAL = 'NORMAL';
export const TWISTED = 'TWISTED';
export const HELPED_KEY = 'MT HELPED';
export const YOUTUBE_MT = 'https://youtu.be/qDyAtzhbuHg';
